export const article = [
  {
    articleId: 33,
    url: "resolucion-de-problemas-de-pago",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Resolución de problemas de pago",
    content: 
      <>
        <div className="row">
          <p>Si hay un problema con tu forma de pago, aquí encontrarás algunas de las causas más comunes y sugerencias para resolver el inconveniente. </p>
        </div>
        <div className="rowLine">
          <h2>Se rechazó la forma de pago</h2>
          <p>Si el banco o la institución financiera rechazan el cargo: </p>
          <ul className="disc">
            <li>Asegúrate de que tu información de pago (como código postal, código de seguridad o fecha de vencimiento) sea correcta. 
              <ul className="disc">
                <li>Si no es así, inicia sesión en tu Cuenta y selecciona Administrar información de pago. También puedes probar otra forma de pago. </li>
                <li>Si todo está correcto, puedes volver a intentar el pago.</li>
              </ul>
            </li>
            <li>Si sigues teniendo problemas, asegúrate de que tu forma de pago admita transacciones de comercio electrónico. </li>
          </ul>
        </div>
        <div>
          <h2>No se acepta la forma de pago </h2>
          <p>Hay muchas opciones para pagar Mega GO, entre ellas, tarjetas de crédito o débito y terceros. Si alguna de nuestras formas de pago aceptadas no funciona, contáctanos.</p>
        </div>
      </>
  }
];